let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4uC1s")).then(() => parcelRequire('h344f'));